import { jsx as _jsx } from "react/jsx-runtime";
import { AnnotationLayer } from "pdfjs-dist";
import { memo, useLayoutEffect, useRef } from "react";
export const PDFPageAnnotationLayer = /*#__PURE__*/ memo((param)=>{
    let { pdfPage, linkService, pageViewport } = param;
    const containerRef = useRef(null);
    const annotationLayerRef = useRef();
    const isMounted = useRef(false);
    useLayoutEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    useLayoutEffect(()=>{
        const hide = ()=>{
            if (containerRef.current) {
                containerRef.current.hidden = true;
            }
        };
        const show = ()=>{
            if (containerRef.current) {
                containerRef.current.hidden = false;
            }
        };
        const renderAnnotations = async ()=>{
            if (annotationLayerRef.current) {
                // @ts-ignore - incorrect type in update method
                annotationLayerRef.current.update({
                    viewport: pageViewport.clone({
                        dontFlip: true
                    })
                });
                return;
            }
            const annotations = await pdfPage.getAnnotations();
            if (annotations.length === 0) {
                hide();
                return;
            }
            annotationLayerRef.current = new AnnotationLayer({
                div: containerRef.current,
                page: pdfPage,
                viewport: pageViewport.clone({
                    dontFlip: true
                }),
                accessibilityManager: null,
                annotationEditorUIManager: null,
                annotationCanvasMap: null
            });
            if (!containerRef.current) return;
            await annotationLayerRef.current.render({
                annotations,
                renderForms: false,
                linkService: linkService,
                div: containerRef.current,
                page: pdfPage,
                viewport: pageViewport.clone({
                    dontFlip: true
                })
            });
            if (!isMounted.current) {
                return;
            }
            show();
        };
        renderAnnotations();
    }, [
        linkService,
        pageViewport,
        pdfPage
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "pdfAnnotationLayer",
        ref: containerRef
    });
});
PDFPageAnnotationLayer.displayName = "PDFPageAnnotationLayer";
